<template>
    <div class="col-12" :class="show ? 'mb-5' : ''">
        <h4 v-if="show" class="pt-3">{{ title }}</h4>
        <v-alert v-if="alert"></v-alert>
    </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: null
      },
      alert: {
        type: Boolean,
        default: true
      },
      show: {
          type: Boolean,
          default: true,
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/includes/TitlePage.vue